import { Box, BoxProps, Fade } from '@mui/material';

interface UnreadNotificationProps extends BoxProps {
    show: boolean;
}

function UnreadNotification({ show, sx, ...restProps }: UnreadNotificationProps) {
    return (
        <Fade in={show}>
            <Box
                component="span"
                sx={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: -16,
                    margin: 'auto',
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: 'error.main',
                    marginRight: 1,
                    ...sx,
                }}
                {...restProps}
            />
        </Fade>
    );
}

export default UnreadNotification;
